import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import ColumnH1 from '../atoms/columnH1'
import Introduction004 from './Introduction004'
import Introduction005 from './Introduction005'
import Introduction006 from './Introduction006'
import Introduction007 from './Introduction007'
import Introduction008 from './Introduction008'
import Introduction009 from './Introduction009'
import Introduction010 from './Introduction010'
import Introduction011 from './Introduction011'
import Introduction012 from './Introduction012'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 30px;

  .p-txt-date {
    margin-top: -10px;
    color: #ababab;
  }

  section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 16px;
    color: #505050;
    line-height: 1.6em;

    h1 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #f5f5f5;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-bottom: 30px;
      margin-top: 10px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #77d7c9;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h2 {
      color: #414141;
      font-size: 22px;
      line-height: 1.4em;
      background: #ffffff;
      border-radius: 3px;
      position: relative;
      width: 100%;
      padding: 5px 5px 5px 20px;
      margin-top: 10px;
      margin-bottom: 30px;

      &:before {
        content: '';
        position: absolute;
        width: 10px;
        background: #d8d8d8;
        left: 0;
        top: 0;
        border-radius: 3px 0 0 3px;
        height: 100%;
      }
    }

    h3 {
      color: #414141;
      font-size: 16px;
      line-height: 1.4em;
      background: #ffffff;
      width: auto;
      padding: 10px 0 8px;
      margin-top: -10px;
      margin-bottom: 20px;
      border-top: solid 2px #e5e5e5;
      border-bottom: solid 2px #e5e5e5;
    }

    p {
      padding-bottom: 30px;
      line-height: 2;
      position: relative;

      span {
        background: linear-gradient(transparent 60%, #ff6 60%);
        font-weight: 600;
      }

      .p-list-link {
        position: absolute;
        top: 6px;
        right: 2px;

        &:before {
          display: block;
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          top: 7px;
          left: -14px;
          border-left: 8px solid #3ec7b3;
          border-top: 4px solid transparent;
          border-bottom: 4px solid transparent;
        }
      }

      &.txt-color-red {
        color: #ff6969;
      }
    }

    .link-div {
      width: 100%;
      display: flex;
      justify-content: left;
      padding-bottom: 30px;

      > div {
        width: 50px;
      }

      .link-p {
        width: calc(100% - 50px);

        .p-list-link {
          position: absolute;
          top: -3px;
          left: 30px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 11px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      padding-bottom: 30px;
    }
  }

  ${BreakPoints.large} {
  }
`
type Props = {
  /** 広告の番号 */
  no: number
}

/**
 * コラム記事詳細：記事本体
 * @constructor
 */
const ColumnDetailInner0103 = (props: Props): JSX.Element => (
  <Wrapper>
    <ColumnH1 label="パートタイム・有期雇用労働法の改正について" />
    {/** TODO 川上申し送り事項：▼投稿日をここに表示 */}
    <p className="p-txt-date">2026.06.03</p>
    <section>
      {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
      <p>
        2020年4月よりパートタイム・有期雇用労働法が施行されています。中小企業については翌年の2021年4月施行ではあるものの、パートタイム労働者を雇用する企業にとっては避けて通ることのできない法改正です。今回は同法の法改正の概要等について解説します。
      </p>
      <img src="/images/column/details/c0103.jpg" alt="キンクラコラム画像103" />
      <div id="toc1">
        <h1>法改正の概要</h1>
      </div>
      <p>
        同一企業内における正社員とパートタイム労働者の
        <span>不合理な待遇の格差を是正することを目的</span>
        としており、どのような雇用形態を選択しても納得して働き続けられるように同法が施行されています。特に働き方改革以降は多様な働き方が尊重され始めているものの、
        <span>
          不合理な待遇の格差が引き金となり、労働者が労働市場から退いていくという判断をしてしまうケースもあります
        </span>
        。
        <br />
        <br />
        同法の概要としては次の3点が挙げられます。
        <span>
          一つは不合理な待遇の格差を禁ずること、次に、労働者の待遇についての説明責任を果たすこと、最後に、裁判以外の労使紛争の解決手続きの整備
        </span>
        です。特に一点目の不合理な待遇の格差については想定される範囲は多岐にわたり、裁判にまで発展している事案は少なくありません。
      </p>

      <div id="toc2">
        <h1>主な改正内容</h1>
      </div>
      <p>
        <span>
          不合理な待遇の格差については、基本給だけでなく、賞与についても対象に含まれており、差を設ける場合は一定の基準が求められます
        </span>
        。これは裁判においても重要な意味を持つ論点です。
        <br />
        <br />
        労働者の待遇についての説明責任については、雇用形態の違いによる一定の相違は実務上もある程度やむを得ないと考えられますが、
        <span>労働者が事業主に対して説明を求めることが可能となっています</span>
        。具体的には雇用管理上の措置の内容や、待遇決定時の考慮事項等が挙げられます。そして、説明を求めた労働者に対する不利益取り扱いも禁止されています。
      </p>

      <div id="toc3">
        <h1>勤怠管理に与える影響</h1>
      </div>
      <p>
        例えば
        <span>遅刻の処理一つとっても影響が大きいです</span>
        。具体例として、正社員に限り、公共交通機関の遅延に起因し、遅刻した場合は遅刻控除を行わないものの、非正規社員については同様の理由であっても遅刻控除を行うといった場合には、当然、勤怠から給与計算に移行するフェーズにおいて煩雑であるだけでなく、そもそも明確な理由も見出しづらいと考えられます。
        <span>
          単なる寝坊や自家用車の故障が原因での遅刻とは異なるため、何らかの是正が求められます
        </span>
        。
        <br />
        <br />
        また、手当の相違も挙げられます。勤怠では時間外労働の管理も必須事項ですが、職務に関連する手当は時間外労働手当の基礎額に算入しなければなりません。これらの手当について、正社員には付与されるものの、非正規社員に付与されない場合、同じ基本給で同じ時間外労働時間数でも実際に支給される時間外労働手当額は異なります。当然、
        <span>
          当該手当が付与されない理由について労働者より説明を求められた場合は事業主は説明責任を負います
        </span>
        ので、注意が必要です。
      </p>

      {/** ここに9パターンの広告設定する */}
      {props.no === 0 && <Introduction004 />}
      {props.no === 1 && <Introduction005 />}
      {props.no === 2 && <Introduction006 />}
      {props.no === 3 && <Introduction007 />}
      {props.no === 4 && <Introduction008 />}
      {props.no === 5 && <Introduction009 />}
      {props.no === 6 && <Introduction010 />}
      {props.no === 7 && <Introduction011 />}
      {props.no === 8 && <Introduction012 />}

      <div id="toc4">
        <h1>労働時間の一貫性</h1>
      </div>
      <p>
        <span>始業時刻前の打刻時間の運用方法も重要論点</span>
        です。例えば正社員と非正規社員での運用方法に相違があり、労働者より説明を求められた場合は事業主は説明責任を負います。もちろん、個々人の民度にもよりますし、管理的な立場を担うことが多い正社員との職務の差等、考慮すべき事項は複数ありますが、
        <span>不合理と推察される差があれば、再考の余地はあります</span>。
      </p>

      <div id="toc5">
        <h1>有給休暇の管理</h1>
      </div>
      <p>
        本来、
        <span>法律上認められるものではありませんが、事後的な有給処理です</span>
        。本来、有給休暇は暦日単位が原則であり、
        <span>
          少なくとも始業時刻を過ぎてからの有給の申し出は事業主として受理する義務はありません
        </span>
        。また、このような運用を認め続けることでルーズな職場風土が形成されてしまうなど、マイナス面も出てくることが容易に想像されます。この場合、正社員と非正規社員との運用面での差があれば、内容によっては問題となるケースも想定されます。
      </p>

      <div id="toc6">
        <h1>労働条件の説明と記録</h1>
      </div>
      <p>
        <span>
          労働条件は賃金や労働時間など、労使間での約束事の根幹となる部分が含まれており
        </span>
        、特に前述の賃金や労働時間は契約内容の重要事項に挙げられるものです。確かに正社員の方が待遇面（手当等）が多く、説明に時間を要することはあり得ますが、非正規社員であっても
        <span>
          労働条件は重要であり、特に有期契約労働者の場合は、雇用契約期間については正社員には存在しないものですので、より慎重な説明が求められます
        </span>
        。また、それだけでなく、更新の際の基準（例えば業務量や、勤務成績）については明確に示しておかなければトラブルになることは想像に難くありません。特に勤務成績については何らかの基準を示しておかなければ曖昧になりやすい分野であることから注意が必要です。
      </p>

      <div id="toc7">
        <h1>勤怠管理システムの導入</h1>
      </div>
      <p>
        同法の対応については、多くの場合、勤怠管理を担う人事労務部門が対応部署であることが一般的です。そうなると、
        <span>
          前述の格差がありながらの勤怠管理は複雑であり、システム導入をすることで作業の簡素化を進めることが可能となります
        </span>
        。
      </p>

      <div id="toc8">
        <h1>内部監査の実施</h1>
      </div>
      <p>
        一般的な状態と比較して自社では何が問題となり得る格差なのかは社内のみでは判断に迷うケースが多く見受けられます。よって、外部からの内部監査を経て、客観的に問題を炙り出すという選択肢も現実的です。
      </p>

      <div id="toc9">
        <h1>最後に</h1>
      </div>
      <p>
        特に内部監査の実施は痛みを伴う作業であるため、敬遠されがちではありますが、実効性のある法改正対応とするには一考の価値があると考えます。
      </p>
    </section>
  </Wrapper>
)

export default ColumnDetailInner0103
